// *************************** Validators ***********************
exports.currencyValidate = function(value) {
  let isValid = true;
  const pattern = new RegExp(/^\d+(\.\d{1,7})?$/);
  if (value?.indexOf(',') !== -1) {
    value = value.split(',');
    value = value.join('');
  }
  if (!pattern.test(Number(value))) {
    isValid = false;
  }
  return isValid;
};

exports.nameValidate = function(value) {
  let isValid = true;
  var pattern = new RegExp(/^[a-zA-Z ]*$/);
  if (!pattern.test(value)) {
    isValid = false;
  }
  return isValid;
};
exports.digitsOnly = function(value) {
  if (!value) return 1;
  let isValid = true;
  var pattern = new RegExp(/^[0-9\b]+$/);
  if (!pattern.test(value)) {
    isValid = false;
  }
  return isValid;
};
exports.otpValidation = function(value) {
  let isValid = true;
  var pattern = new RegExp(/^[0-9\s\$^]*$/);
  if (!pattern.test(value)) {
    isValid = false;
  }
  return isValid;
};
exports.alphanumberic = function(value) {
  let isValid = true;
  var pattern = new RegExp(/^[0-9a-zA-Z]*$/, '');
  if (!pattern.test(value)) {
    isValid = false;
  }
  return isValid;
};
exports.addressValidator = function(value) {
  let isValid = true;
  var pattern = new RegExp(/^[ 0-9a-zA-Z]*$/);
  if (!pattern.test(value)) {
    isValid = false;
  }
  return isValid;
};
exports.emailValidator = function(value) {
  if (!value) return 'blank';
  let isValid = true;
  var pattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
  );
  if (!pattern.test(value)) {
    isValid = false;
  }
  return isValid;
};
//************************************************************** */
